export default __webpack_public_path__ + "static/media/GatewayToKhitai.9a57c70e.jpg";